import { render, staticRenderFns } from "./ModuleChoose.vue?vue&type=template&id=5335504c&scoped=true&"
import script from "./ModuleChoose.vue?vue&type=script&lang=js&"
export * from "./ModuleChoose.vue?vue&type=script&lang=js&"
import style0 from "./ModuleChoose.vue?vue&type=style&index=0&id=5335504c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335504c",
  null
  
)

export default component.exports